import { ComplianceStatus } from '../../../types/AISystems.types';

export type FilterOption = { value: string; label: string };

// Static baseline for the entity/role filter. Used as the union seed and the
// fallback when dynamic aggregation (from the loaded systems) is unavailable.
// Spans EU AI Act roles and NYC LL144 roles.
export const entityOptions: FilterOption[] = [
  { value: 'PROVIDER', label: 'Provider' },
  { value: 'DEPLOYER', label: 'Deployer' },
  { value: 'DISTRIBUTOR', label: 'Distributor' },
  { value: 'IMPORTER', label: 'Importer' },
  { value: 'PRODUCT_MANUFACTURER', label: 'Product manufacturer' },
  { value: 'AUTHORISED_REPRESENTATIVE', label: 'Authorised representative' },
  { value: 'EMPLOYER', label: 'Employer' },
  { value: 'EMPLOYMENT_AGENCY', label: 'Employment agency' }
];

export const complianceStatusOptions = [
  { value: ComplianceStatus.INITIATED, label: 'Initiated' },
  { value: ComplianceStatus.CLASSIFYING, label: 'Classifying' },
  { value: ComplianceStatus.IN_PROGRESS, label: 'In Progress' },
  { value: ComplianceStatus.COMPLIANT, label: 'Compliant' },
  {
    value: ComplianceStatus.COMPLIANT_RISK_CLASSIFIED,
    label: 'Compliant (Risk-Classified)'
  },
  { value: ComplianceStatus.NON_COMPLIANT, label: 'Non-Compliant' },
  { value: ComplianceStatus.ATTENTION_REQUIRED, label: 'Attention Required' }
];

// Static baseline for the risk/classification filter (union seed + fallback).
// Spans EU AI Act tiers and NYC LL144 classifications.
export const riskClassificationOptions: FilterOption[] = [
  { value: 'MINIMAL_RISK', label: 'Minimal-Risk' },
  { value: 'LIMITED_RISK', label: 'Limited-Risk' },
  { value: 'HIGH_RISK', label: 'High-Risk' },
  { value: 'PROHIBITED', label: 'Prohibited' },
  { value: 'OTHER', label: 'Other' },
  { value: 'IN_SCOPE', label: 'In Scope' },
  { value: 'OUT_OF_SCOPE', label: 'Out of Scope' }
];
